import { Fragment } from 'react';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { Schema } from '../queries';
import { SchemaDisplay } from './schema-display';

interface Props {
  schemaId: string;
  schema: Schema;
  path?: string;
}

export function SchemaDisplayObject({ schema, schemaId, path = '' }: Props) {
  const level = path.split('.').length;

  if (schema.type !== 'object') {
    return null;
  }

  const Wrapper = level > 2 ? Card.InnerContent : Fragment;

  return (
    <ListLayout.Stack>
      <Wrapper>
        <ListLayout.Column>
          {level <= 2 && <Card.Separator />}

          {/*
            Unless the nesting level equals two, we should split the label and the content by a seperator.
            We also use a fragment, to fix the spacing, given that the parent specifies gap, or similar.
          */}
          {level !== 2 ? (
            <Fragment>
              <ListLayout.SecondaryText>{schema.title}</ListLayout.SecondaryText>
              <Card.Separator />
            </Fragment>
          ) : (
            <ListLayout.PrimaryText>{schema.title}</ListLayout.PrimaryText>
          )}

          {Object.entries(schema.properties || {}).map(([key, value]) => (
            <SchemaDisplay schema={value} schemaId={schemaId} path={`${path ? `${path}.` : ''}${key}`} key={key} />
          ))}
        </ListLayout.Column>
      </Wrapper>
    </ListLayout.Stack>
  );
}
